<div class="modal-header">
    <h5 class="modal-title">Delete User</h5>
    <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
</div>
<form #deleteForm="ngForm" novalidate [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body">
        <h3 class="mb-4">Are you sure you want to delete this user?</h3>
        <ul class="list-unstyled mb-4">
            <li>Name: {{deleteUser.fullName}}</li>
            <li>Email: {{deleteUser.emailAddress}}</li>
            <li>Date Added: {{deleteUser.dateAdded | localDate}}</li>
        </ul>
        <div class="alert alert-danger mb-4">
            <p class="text-strong m-0">This action cannot be undone and all data associated with this user will be lost.
            </p>
        </div>
        <label for="deleteConfirm" class="form-label">Please type "delete" in the box below to proceed.<sup
                class="text-danger">*</sup></label>
        <input type="text" focus-me #deleteConfirm="ngModel" id="deleteConfirm" name="deleteConfirm"
            class="form-control form-control-lg" required [(ngModel)]="deleteUser.message" mustEqual="delete"
            [ngClass]="{'is-invalid': submitAttempt && (deleteForm.controls['deleteConfirm'].errors)}" />
        <div class="invalid-feedback">
            <i class="fas fa-exclamation-circle"></i> This field must equal 'delete'.
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="close()"><i
                class="far fa-times"></i> Cancel</button>
        <button type="submit" class="btn btn-danger btn-round btn-lg" (click)="confirm()"><i
                class="far fa-trash-alt"></i> Delete User</button>
    </div>
</form>